import "../App.css";

export function FetchError({ message, onRetry }) {
  return (
    <div className="image-error">
      <strong>{message}</strong>
      {onRetry && (
        <button className="regen-btn" onClick={onRetry} style={{ marginTop: "0.75rem" }}>
          Retry
        </button>
      )}
    </div>
  );
}
